import {ILabel} from '../../types'

export default {
    serverError: <ILabel>{
        de: 'Unbekannter Fehler, bitte versuchen Sie es erneut',
        en: 'Unknown error, please try again',
        es: 'Error desconocido por favor intente otra vez',
        fr: 'Erreur inconnue, veuillez réessayer',
        nl: 'Onbekende fout, probeer het opnieuw',
        it: 'Si è verificato un errore sconosciuto. Si prega di riprovare.',
    },
    invalidForm: <ILabel>{
        de: 'Bitte die markierten Felder ergänzen und erneut absenden',
        en: 'Please complete the marked fields and send again',
        es: 'Por favor complete los campos marcados y envíe de nuevo',
        fr: 'Veuillez compléter les champs marqués et envoyer à nouveau',
        nl: 'Vul de gemarkeerde velden in en verstuur opnieuw',
        it: 'Si prega di compilare i campi contrassegnati e inviare di nuovo',
    },
    invalidEmpty: <ILabel>{
        de: 'Bitte ausfüllen',
        en: 'Please fill in',
        es: 'Por favor rellene',
        fr: 'Veuillez compléter',
        nl: 'Gelieve in te vullen',
        it: 'Si prega di completare',
    },

    email: <ILabel>{
        de: 'E-Mail',
        en: 'Email',
        es: 'E-Mail',
        fr: 'Email',
        nl: 'E-Mail',
        it: 'E-Mail',
    },
    password: <ILabel>{
        de: 'Passwort',
        en: 'Password',
        es: 'Contraseña',
        fr: 'Mot de passe',
        nl: 'Wachtwoord',
        it: 'Password',
    },
    register: <ILabel>{
        de: 'Registrieren',
        en: 'Register',
        es: 'Registrarse',
        fr: 'S\'enregistrer',
        nl: 'Registreren',
        it: 'Registrati',
    },

    ringsize: <ILabel>{
        de: 'Ringgröße',
        en: 'Ringsize',
        es: 'Talla del anillo',
        fr: 'Tallie de Bague',
        nl: 'Ringmaat',
        it: 'Misure anelli',
    },
    material: <ILabel>{
        de: 'Edelmetall',
        en: 'Precious Metal',
        es: 'Metal precioso',
        fr: 'Métal précieux',
        nl: 'Edelmetaal',
        it: 'Metallo prezioso',
    },
    articleNumber: <ILabel>{
        de: 'Artikel-Nr.',
        en: 'Item Number',
        es: 'Nr. Artículo',
        fr: 'N° Art.',
        nl: 'Artikel-nr.',
        it: 'SKU',
    },

    bidSuccessful: <ILabel>{
        de: 'Gebot erfolgreich',
        en: 'Bid successful',
        es: 'Puja aceptada',
        fr: 'Offre acceptée',
        nl: 'Succesvol bod',
        it: 'Offerta accettata con successo',
    },
    
    // variant labels
    
    variantMaterial: (material: string): ILabel|null => {
        
        // todo: extend list if necessary!!!
        
        // silver
        if(material === 'SS') {
            return <ILabel>{
                de: 'Sterling Silber',
                en: 'Sterling Silver',
                es: 'Plata Sterling',
                fr: 'Argent massif',
                nl: 'Sterling Zilver',
                it: 'Argento sterling',
            }
        }   
        if(material === 'RS') {
            return <ILabel>{
                de: 'Silber, rosévergoldet',
                en: 'Silver, rose gold plated',
                es: 'Plata, bañada en oro rosado',
                fr: 'Argent, plaqué or rose',
                nl: 'Zilver, roze verguld',
                it: 'Argento placcato Oro Rosa',
            }
        }
        if(material === 'WS') {
            return <ILabel>{
                de: 'Silber, weißvergoldet',
                en: 'Silver, white gold plated',
                es: 'Plata, bañada en oro blanco',
                fr: 'Argent, plaqué or blanc',
                nl: 'Zilver, wit verguld',
                it: 'Argento placcato Oro Bianco',
            }
        }
        if(material === 'YS') {
            return <ILabel>{
                de: 'Silber, gelbvergoldet',
                en: 'Silver, yellow gold plated',
                es: 'Plata, bañada en oro amarillo',
                fr: 'Argent, plaqué or jaune',
                nl: 'Zilver, geel verguld',
                it: 'Argento placcato Oro Giallo',
            }
        }
        
        // gold
        if(material === 'RG') {
            return <ILabel>{
                de: 'Roségold',
                en: 'Rose Gold',
                es: 'Oro rosado',
                fr: 'Or rose',
                nl: 'Rozegoud',
                it: 'Oro Rosa',
            }
        }
        if(material === 'WG') {
            return <ILabel>{
                de: 'Weißgold',
                en: 'White Gold',
                es: 'Oro blanco',
                fr: 'Or blanc',
                nl: 'Witgoud',
                it: 'Oro Bianco',
            }
        }
        if(material === 'YG') {
            return <ILabel>{
                de: 'Gelbgold',
                en: 'Yellow Gold',
                es: 'Oro amarillo',
                fr: 'Or jaune',
                nl: 'Geelgoud',
                it: 'Oro Giallo',
            }
        }
        
        // other
        
        if(material === '3G') {
            return <ILabel>{
                de: 'Gold, dreifarbig',
                en: 'Three Tone Gold',
                es: 'Oro, tres colores',
                fr: 'Or, tricolore',
                nl: 'Goud, driekleurig',
                it: 'Oro, tricolore',
            }
        }
        if(material === 'WR') {
            return <ILabel>{
                de: 'Weiß- und Roségold',
                en: 'White Gold and Rose Gold',
                es: 'Oro blanco y Oro rosado',
                fr: 'Or blanc et Or rose',
                nl: 'Witgoud en Rozegoud',
                it: 'Oro Bianco e Oro Rosa',
            }
        }
        if(material === 'YW') {
            return <ILabel>{
                de: 'Gelb- und Weißgold',
                en: 'Yellow Gold and White Gold',
                es: 'Oro amarillo y Oro blanco',
                fr: 'Or jaune et Or blanc',
                nl: 'Geelgoud en Witgoud',
                it: 'ro Giallo e Oro Bianco',
            }
        }
        if(material === 'YR') {
            return <ILabel>{
                de: 'Gelb- und Roségold',
                en: 'Yellow Gold and Rose Gold',
                es: 'Oro amarillo y Oro rosado',
                fr: 'Or jaune et Or rose',
                nl: 'Geelgoud en Rozegoud',
                it: 'Oro Giallo e Oro Rosa',
            }
        }
        
        if(material === 'PS') {
            return <ILabel>{
                de: 'Silber, platiniert',
                en: 'Silber, platinated',
                es: 'Plata plateada con platino',
                fr: 'Argent platiné',
                nl: 'Zilver, geplatineerd',
                it: 'Argento placcato Platino',
            }
        }
        if(material === 'PT') {
            return <ILabel>{
                de: 'Platin',
                en: 'Platinum',
                es: 'Platino',
                fr: 'Platine',
                nl: 'Platina',
                it: 'Platino',
            }
        }
        if(material === '2S') {
            return <ILabel>{
                de: 'Silber, teilvergoldet',
                en: 'Silber, partly gold plated',
                es: 'Plata, de dos tonos',
                fr: 'Argent, deux tons',
                nl: 'Zilver, two-tone',
                it: 'Argento placcato bicolore',
            }
        }
        
        return null
    },
    variantRingsize: (ringsize: string): ILabel|null => {
        
        // todo: extend list if necessary!!!
        // todo: en are UK labels only!
        
        if(ringsize === '13') {
            return <ILabel>{
                de: '13',
                en: '13',
                es: '1',
                fr: '41',
                nl: '13',
                it: '1',
            }
        }
        if(ringsize === '14') {
            return <ILabel>{
                de: '14',
                en: '14',
                es: '4',
                fr: '44',
                nl: '14',
                it: '4',
            }
        }
        if(ringsize === '15') {
            return <ILabel>{
                de: '15',
                en: '15',
                es: '7',
                fr: '47',
                nl: '15',
                it: '7',
            }
        }
        if(ringsize === '16') {
            return <ILabel>{
                de: '16',
                en: '16',
                es: '11',
                fr: '50',
                nl: '16',
                it: '11',
            }
        }
        if(ringsize === '17') {
            return <ILabel>{
                de: '17',
                en: '17',
                es: '14',
                fr: '54',
                nl: '17',
                it: '14',
            }
        }
        if(ringsize === '18') {
            return <ILabel>{
                de: '18',
                en: '18',
                es: '17',
                fr: '57',
                nl: '18',
                it: '17',
            }
        }
        if(ringsize === '19') {
            return <ILabel>{
                de: '19',
                en: '19',
                es: '20',
                fr: '60',
                nl: '19',
                it: '20',
            }
        }
        if(ringsize === '20') {
            return <ILabel>{
                de: '20',
                en: '20',
                es: '23',
                fr: '63',
                nl: '20',
                it: '23',
            }
        }
        if(ringsize === '21') {
            return <ILabel>{
                de: '21',
                en: '21',
                es: '26',
                fr: '66',
                nl: '21',
                it: '26',
            }
        }
        if(ringsize === '22') {
            return <ILabel>{
                de: '22',
                en: '22',
                es: '29',
                fr: '69',
                nl: '22',
                it: '29',
            }
        }
        if(ringsize === '23') {
            return <ILabel>{
                de: '23',
                en: '23',
                es: '32',
                fr: '72',
                nl: '23',
                it: '32',
            }
        }
        if(ringsize === '24') {
            return <ILabel>{
                de: '24',
                en: '24',
                es: '35',
                fr: '75',
                nl: '24',
                it: '35',
            }
        }
        
        return null
    }
}